import { render, staticRenderFns } from "./stamp.vue?vue&type=template&id=d47f6ef4&scoped=true&"
import script from "./stamp.vue?vue&type=script&lang=js&"
export * from "./stamp.vue?vue&type=script&lang=js&"
import style0 from "./stamp.vue?vue&type=style&index=0&id=d47f6ef4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47f6ef4",
  null
  
)

export default component.exports